import { render, staticRenderFns } from "./detailsTop.vue?vue&type=template&id=39c9f29b&scoped=true"
import script from "./detailsTop.vue?vue&type=script&lang=ts&setup=true"
export * from "./detailsTop.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./detailsTop.vue?vue&type=style&index=0&id=39c9f29b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c9f29b",
  null
  
)

export default component.exports